import { CircularProgress } from "@mui/material";
import { context } from "..";
import Logo from "../misc/Logo";


export default function FallbackPage () {
    
    return (
        <div className="main-inner">
            <div style={{padding: "15vh 0"}}>
                <h1 style={{fontSize: "8vw", fontWeight: "800", lineHeight: "8vw"}}>Data Driven Questionnaires</h1>
                
                <h1 style={{fontWeight: "600", marginTop: "15px"}}>by <Logo width={80} type="block" /></h1>
                
                <p>Keeping data-entry to a minimum</p>

                {context.questionnaire?.completionRedirectUri && context.redirectCountdown !== null && context.redirectCountdown > -1 ? (
                    <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                        <CircularProgress style={{width: "12px", height: "12px"}} color="secondary" />

                        <p>Redirecting you in {context.redirectCountdown}.</p>
                    </div>
                ) : null}
            </div>
        </div>
    )
}